import { defineComponent, computed, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Popup } from 'vant';
import { Auth, Device, Env } from '@nio-pow/mfe-vue3';
import CellSelect from '@/components/CellSelect/index.vue';
import BizArea from './BizArea.vue';
import { HeaderUtils, showHeaderNav, showPCHeaderV2, apiGetEmployeeInfo, useEnvHint } from './HeaderUtils';
import EnvTag from './EnvTag.vue';
import { tabbarRoutes } from '../Layout/mobileTabbarListConfig';
const KEY_FIRST_PAGE = '__POWER-GO-MAIN__FIRST-PAGE__';
export default defineComponent({
    name: 'HeaderNavComp',
    components: {
        'van-popup': Popup,
        CellSelect,
        BizArea,
        EnvTag
    },
    props: {
        // 是否固定在顶部
        fixed: {
            type: Boolean,
            default: false
        },
        // 是否黏贴在顶部
        sticky: {
            type: Boolean,
            default: false
        }
    },
    setup (props) {
        const route = useRoute();
        const router = useRouter();
        const { showEnvHint } = useEnvHint();
        const isMobile = Device.isMobile();
        const isInternational = Env.isInternational();
        const titleDefault = 'PowerGo';
        const title = ref(titleDefault);
        const titleOptions = ref([]);
        const titleSelected = ref(null);
        const titleChangeCallback = ref(null);
        const showTitleOptions = ref(false);
        const showTitleOptionsWrapper = ref(false);
        // 头像等其他员工信息
        const employeeInfo = ref({});
        const showBackBtn = computed(()=>{
            if (!isMobile) return true;
            const { showBack } = route.meta;
            if (typeof showBack === 'boolean') return showBack;
            // 支持正则方式进行精确匹配（默认结尾加 $）
            return !tabbarRoutes.some((item)=>new RegExp("^".concat(item, "$")).test(route.path));
        });
        let fullPath = sessionStorage.getItem(KEY_FIRST_PAGE);
        // 监听 document.title 变化，同时变更自定义导航标题
        function observeTitle() {
            const target = document.head.querySelector('title');
            const config = {
                childList: true
            };
            const observer = new MutationObserver(()=>{
                title.value = document.title;
            });
            observer.observe(target, config);
            title.value = document.title || titleDefault;
        }
        function isFirstPage() {
            const historyLen = window.history.length;
            fullPath = sessionStorage.getItem(KEY_FIRST_PAGE);
            return historyLen === 1 || fullPath === window.location.href;
        }
        function handleBack() {
            if (isMobile && isFirstPage()) {
                window.history.replaceState({}, '', '/');
            } else {
                router.back();
            }
        }
        function toggleTitleOptions(flag) {
            showTitleOptions.value = typeof flag === 'boolean' ? flag : !showTitleOptions.value;
        }
        function toggleTitleOptionsWrapper(flag) {
            const res = typeof flag === 'boolean' ? flag : !showTitleOptionsWrapper.value;
            showTitleOptionsWrapper.value = res;
        }
        function handleTitleOptionChange(option) {
            toggleTitleOptions(false);
            if (typeof titleChangeCallback.value === 'function') {
                titleChangeCallback.value(option);
            }
        }
        function handleLogoClick() {
            window.history.pushState({}, '', '/');
        }
        if (!fullPath) {
            sessionStorage.setItem(KEY_FIRST_PAGE, window.location.href);
        }
        observeTitle();
        HeaderUtils.onTitleOptionsChange((payload)=>{
            if (payload === false) {
                titleOptions.value = [];
                titleSelected.value = null;
                titleChangeCallback.value = null;
            } else {
                const { options, defaultIndex, callback } = payload;
                titleOptions.value = options ? [
                    ...options
                ] : [];
                titleSelected.value = titleOptions.value[defaultIndex] || titleOptions.value[0];
                titleChangeCallback.value = callback;
            }
        });
        const userInfo = ref({});
        onMounted(()=>{
            userInfo.value = Auth.getUserInfo();
            // 查询员工信息（头像）
            apiGetEmployeeInfo(userInfo.value.userId).then((res)=>{
                if (res.resultCode === 'success') {
                    employeeInfo.value = res.data;
                }
            });
        });
        return {
            router,
            userInfo,
            employeeInfo,
            showBackBtn,
            isInternational,
            titleOptions,
            title,
            titleSelected,
            showTitleOptions,
            showTitleOptionsWrapper,
            showHeaderNav,
            showPCHeaderV2,
            showEnvHint,
            handleBack,
            toggleTitleOptions,
            handleTitleOptionChange,
            toggleTitleOptionsWrapper,
            handleLogoClick
        };
    }
});
